// removed by extract-text-webpack-plugin
module.exports = {"avatarContainer":"_11PmkTeaUDRuuR4JaoTw-Q","dropdownContainer":"_3ji9NcyeVwFd8V5-C_HSCS","option":"_6iem7pgQUbHDhdXVfIZ3P","name":"_3aidbjJVNxlDLZX104e08J","email":"_24JIWDGM_QbXjV8COxb2t","logout":"_2J6vbg_txMcIxiJnVky8QL"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/LogOut/LogOut.pcss
// module id = 855
// module chunks = 0